/** Public CMS calls — no auth required (token optional). */
export const publicApi = async ({ url, method = "GET", body = null }) => {
  const baseURL = process.env.REACT_APP_API_URL;
  const options = {
    method,
    headers: { "Content-Type": "application/json" },
  };
  if (body) options.body = JSON.stringify(body);

  const response = await fetch(`${baseURL}/${url}`, options);
  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.status}`);
  }
  return response.json();
};
